export enum InputState{
    User_Input,
    Input_Blur,
    Not_Set
}